import { X } from 'lucide-react';
import type { ReactNode } from 'react';
import { Button } from '~/components/ui/buttons/Button';

interface FilterSidebarProps {
  title: string;
  onClose: () => void;
  onApply: () => void;
  onClear: () => void;
  children: ReactNode;
}

export function FilterSidebar({
  title,
  onClose,
  onApply,
  onClear,
  children,
}: FilterSidebarProps) {
  return (
    <div className="w-72 shrink-0 bg-neut-bg-alt rounded-lg border border-neut-border shadow-sm p-4 flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold text-neut-prim">{title}</h3>
        <button
          type="button"
          onClick={onClose}
          className="text-neut-sec hover:text-neut-prim transition-colors"
          aria-label="Close filter panel"
          title="Close filter panel"
        >
          <X size={16} />
        </button>
      </div>

      {children}

      <div className="flex gap-2 pt-2">
        <Button onClick={onApply} className="flex-1">
          Apply
        </Button>
        <Button onClick={onClear}>Clear</Button>
      </div>
    </div>
  );
}
